// NO EDITAR A MANO
import idiomas from "../_idiomas";

export default idiomas;
